"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _menu = require("../utils/menu");

var _requester2 = _interopRequireDefault(require("./requester"));

var _common = require("../utils/common");

var _constant = require("../constant");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
 * 数据管理的查询扩展类
 * 注：数据的请求，是从table树的根节点开始，逐层的往下填充table数据
 */
var GetRequester = /*#__PURE__*/function (_requester) {
  (0, _inherits2["default"])(GetRequester, _requester);

  var _super = _createSuper(GetRequester);

  function GetRequester() {
    (0, _classCallCheck2["default"])(this, GetRequester);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(GetRequester, [{
    key: "getAllDataList",

    /**
     * 获取多条主表数据的table树数据
     */
    value: function () {
      var _getAllDataList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var mainTable, result, resultCount, allPromise, dataList;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                mainTable = this.tableTree;
                allPromise = [];
                allPromise.push(this.wujiApi.getDataList(mainTable).then(function (data) {
                  result = data;
                }));
                allPromise.push(this.wujiApi.getDataList(mainTable, true).then(function (data) {
                  resultCount = data;
                }));
                _context.next = 6;
                return (0, _common.allSettled)(allPromise);

              case 6:
                if (result) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", {
                  dataList: [],
                  dataCount: resultCount
                });

              case 8:
                mainTable.dataList = result; // 这里会完成table树所有节点的数据填充

                _context.next = 11;
                return this.tableTreeDataGenerate(mainTable);

              case 11:
                // 提取table树所有节点的数据，构建一个数据树
                dataList = this.buildDataTreeByTableTree();
                return _context.abrupt("return", {
                  dataList: dataList,
                  dataCount: resultCount
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAllDataList() {
        return _getAllDataList.apply(this, arguments);
      }

      return getAllDataList;
    }()
    /**
     * 获取一条主表数据的table树数据
     * @param {*} objectId objectId获取主表的单条数据（单条无极api有特殊接口）
     */

  }, {
    key: "getAllDataDetail",
    value: function () {
      var _getAllDataDetail = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(objectId) {
        var mainTable, result;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                mainTable = this.tableTree;
                _context2.next = 3;
                return this.wujiApi.getDataDetail(mainTable, {
                  objectId: objectId
                });

              case 3:
                result = _context2.sent;

                if (result) {
                  _context2.next = 6;
                  break;
                }

                throw Error("objectId=[".concat(objectId, "] getDataDetail result is ").concat(result));

              case 6:
                mainTable.dataList = [result]; // 这里会完成table树所有节点的数据填充

                _context2.next = 9;
                return this.tableTreeDataGenerate(mainTable);

              case 9:
                return _context2.abrupt("return", this.buildDataTreeByTableTree());

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAllDataDetail(_x) {
        return _getAllDataDetail.apply(this, arguments);
      }

      return getAllDataDetail;
    }()
    /**
     * 补充指定table的所有子table数据（递归）
     * @param {*} table table实例
     */

  }, {
    key: "tableTreeDataGenerate",
    value: function () {
      var _tableTreeDataGenerate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(table) {
        var that, forkTableList, allPromise;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = this;
                forkTableList = table.forkTableList;

                if (!(forkTableList.length > 0)) {
                  _context3.next = 11;
                  break;
                }

                allPromise = [];
                forkTableList.forEach(function (forkTableAndRelation) {
                  var forkTable = forkTableAndRelation.forkTable; // 循环补充每个从表关联键值的查询条件：基于真实数据

                  that.setForkTableQueryByRealData(forkTableAndRelation, table.dataList); // 并发 + 批量的请求当前table实例的所有子table数据

                  allPromise.push(that.wujiApi.getDataList(forkTable).then(function (result) {
                    forkTable.dataList = result || [];
                  }));
                });
                _context3.next = 7;
                return (0, _common.allSettled)(allPromise);

              case 7:
                // 对下一层的所有table实例执行同样的操作(并发+递归)
                allPromise = [];
                forkTableList.forEach(function (forkTableAndRelation) {
                  var forkTable = forkTableAndRelation.forkTable;
                  allPromise.push(that.tableTreeDataGenerate(forkTable));
                });
                _context3.next = 11;
                return (0, _common.allSettled)(allPromise);

              case 11:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function tableTreeDataGenerate(_x2) {
        return _tableTreeDataGenerate.apply(this, arguments);
      }

      return tableTreeDataGenerate;
    }()
    /**
    * 基于真实数据 + 表关系：请求子table的数据前，补上关联键的数据作为查询条件
    * @param {*} forkTableAndRelation table实例的子节点：子table实例 + 表关系
    * @param {*} tableDataList table实例的实际数据列表
    */

  }, {
    key: "setForkTableQueryByRealData",
    value: function setForkTableQueryByRealData(forkTableAndRelation, tableDataList) {
      var relationObj = forkTableAndRelation.relationObj,
          forkTable = forkTableAndRelation.forkTable;
      var relation = relationObj.relation;
      var relationValues = []; // 普通关联的键在子表、普通关联的键在父表、反向关联link的键在子表

      if (relation[1] === _menu.RelationStatus.RIGHT || relation[1] === _menu.RelationStatus.LEFT || relation[1] === _menu.RelationStatus.IN) {
        relationValues = tableDataList.filter(function (data) {
          return !!data[relation[0]];
        }).map(function (data) {
          return data[relation[0]];
        });
      } // 反向关联link的键在父表


      if (relation[1] === _menu.RelationStatus.INCLUDE) {
        tableDataList.forEach(function (data) {
          var value = data[relation[0]];

          if (value) {
            // 无极是按字符串存储，英文逗号分割
            relationValues = relationValues.concat(value.split(_constant.LINKSPLIT));
          }
        });
      }

      var fieldSChema = forkTable.schemaList.find(function (item) {
        return item.id === relation[2];
      });

      if (fieldSChema && (fieldSChema.type === 100 || fieldSChema.type === 103)) {
        relationValues = relationValues.map(function (value) {
          return "".concat(value);
        });
      } else {
        relationValues = relationValues.map(function (value) {
          return "\"".concat(value, "\"");
        });
      }

      relationValues = Array.from(new Set(relationValues));
      forkTable.queryRelationList = [{
        key: relation[2],
        value: "[".concat(relationValues, "]"),
        optType: '='
      }];
    }
  }]);
  return GetRequester;
}(_requester2["default"]);

var _default = GetRequester;
exports["default"] = _default;